<script>
    import { writable } from 'svelte/store'
    import Typography from '$lib/components/UI/Typography.svelte'
    import CaretDown from '$lib/components/Icons/CaretDown.svelte'
    import CaretUp from '$lib/components/Icons/CaretUp.svelte'
    export let sortDirective = writable([])
    export let schema = {}
    export let endOfRow = false
    export let ordering = true
    async function toggleSortDirective(key) {
        let pos = $sortDirective.findIndex((x) => x === key || x === `-${key}`)
        let col = pos !== -1 ? $sortDirective[pos] : null
        let negate = col ? col[0] === '-' : null
        if (col !== null) {
            if (negate) {
                $sortDirective = []
            } else {
                $sortDirective[pos] = `-${key}`
            }
        } else {
            await sortDirective.update((all) => [...all, key])
        }
    }
    $: header = Object.keys(schema)
</script>

<tr>
    {#each header as column}
        {@const enableOrdering = ordering && schema[column].ordering}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <td
            on:click={(_) => {
                if (enableOrdering) toggleSortDirective(column)
            }}
        >
            <span class:ordering={enableOrdering}>
                <Typography type="caption" style="font-size: var(--header-font-size)" color="grey-800">
                    {schema[column]?.label || column}
                </Typography>
                <svelte:component
                    this={$sortDirective.includes(column) ||
                    $sortDirective.includes(`-${column}`)
                        ? $sortDirective.includes(column)
                            ? CaretDown
                            : CaretUp
                        : null}
                    size={16}
                />
            </span>
        </td>
    {/each}
    {#if endOfRow}
        <td></td>
    {/if}
</tr>

<style>
    :root{
        --header-font-size: 14px;
    }
    span {
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;
    }
    .ordering {
        cursor: pointer;
    }
</style>
